import React from 'react';
import styled from 'styled-components';
import { bool, string } from 'prop-types';

const Container = styled.div`
  background: url('${process.env.PUBLIC_URL}/images/discount-tag.svg') no-repeat;
  background-size: contain;
  max-width: 75px;
  min-width: 66px;
  position: absolute;
  top: ${({ recommended }) => (recommended ? '50px' : '19px')};
  left: -8px;
  padding: 2px 0px 5px 8px;
`;

const Text = styled.p`
  font-family: 'Nunito Sans', sans-serif;
  padding-top: 2px;
  font-size: 10px;
  font-weight: bold;
  line-height: 1.17;
  text-align: left;
  color: #fff;
`;

const DiscountTag = ({ recommended, text }) => (
  <Container recommended={recommended}>
    <Text>{text}</Text>
  </Container>
);

export default DiscountTag;

DiscountTag.propTypes = {
  recommended: bool,
  text: string.isRequired,
};

DiscountTag.defaultProps = {
  recommended: false,
};
